/* eslint-disable max-len */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
export const resources = {
  en: {
    translation: {
      Home: 'Home',
      'Recently Visited': 'Recently Visited',
      'See All': 'See All',
      Welcome: 'Welcome',
      'Your Programs': 'Your Programs',
      Recommendations: 'Recommendations',
      'Show More': 'Show More',
      'New!': 'New!',
      Stream: 'Stream',
      'You assigned': 'You assigned',
      'on DATE': 'on DATE',
      'Go to Lesson': 'Go to Lesson',
      'View Work': 'View Work',
      'Here is where you will find suggested next steps, reminders, and notifications about helpful resources.':
        'Here is where you will find suggested next steps, reminders, and notifications about helpful resources.',
      'Here you will find your class activity. Click “See All” to view your activity since the beginning of the school year. There, you can also filter by class if you have multiple classes.':
        'Here you will find your class activity. Click “See All” to view your activity since the beginning of the school year. There, you can also filter by class if you have multiple classes.',
      'Here you will find your class activity. After you have taught your first four lessons, a “See All” button will appear where you can view your activity since the beginning of the school year. There, you can also filter by class if you have multiple classes.':
        'Here you will find your class activity. After you have taught your first four lessons, a “See All” button will appear where you can view your activity since the beginning of the school year. There, you can also filter by class if you have multiple classes.',
      'Explore Quick Links for easy access other locations in the Amplify experience.':
        'Explore Quick Links for easy access other locations in the Amplify experience.',
      'Welcome to Educator Home! Here are each of your programs. Click on one to jump in and quickly access what you need for each day.':
        'Welcome to Educator Home! Here are each of your programs. Click on one to jump in and quickly access what you need for each day.',
      'Quickly jump back into your recently viewed lessons and activities to continue where you left off.':
        'Quickly jump back into your recently viewed lessons and activities to continue where you left off.',
      Programs: 'Programs',
      All: 'All',
      Program: 'Program',
      Archived: 'Archived',
      Unarchived: 'Unarchived',
      Edit: 'Edit',
      Unassign: 'Unassign',
      Unassigned: 'Unassigned',
      Undo: 'Undo',
      'You generated a code for': 'You generated a code for',
      Code: 'Code',
      'Show Expiration Date': 'Show Expiration Date',
      'Hide Expiration Date': 'Hide Expiration Date',
      'm Ago': 'm Ago',
      'h Ago': 'h Ago',
      'd Ago': 'd Ago',
      'a few seconds ago': 'a few seconds ago',
      'Quick Links': 'Quick Links',
      'Manage Classes': 'Manage Classes',
      'PD Library': 'PD Library',
      'Desmos Classroom': 'Desmos Classroom',
      'Custom Activities': 'Custom Activities',
      'Preview Student Home': 'Preview Student Home',
      'Scheduled Assignments': 'Scheduled Assignments',
      'Edit your Avatar': 'Edit your Avatar',
      'Show Less': 'Show Less',
      Reassigned: 'Reassigned',
      Reassign: 'Reassign',
      'Due Date': 'Due Date',
      'Make your avatar': 'Make your avatar',
      Back: 'Back',
      More: 'More',
      Next: 'Next',
      Done: 'Done',
      Assignment: 'Assignment',
      Activities: 'Activities',
      Lessons: 'Lessons',
      'Assign to': 'Assign to',
      Schedule: 'Schedule',
      Immediately: 'Immediately',
      'No due date': 'No due date',
      'Update assignment': 'Update assignment',
      Close: 'Close',
      Support: 'Support',
      'Oops! Something went wrong.': 'Oops! Something went wrong.',
      'Please contact our support team.': 'Please contact our support team.',
      '<b>Your programs are not set up.</b><br />Please contact your principal to inquire<br />who is responsible for setting up schedules in STARS<br />and ensuring all classes are finalized.':
        '<b>Your programs are not set up.</b><br />Please contact your principal to inquire<br />who is responsible for setting up schedules in STARS<br />and ensuring all classes are finalized.',
      'You have successfully joined Amplify':
        'You have successfully joined Amplify',
      'Invite expired. Please contact your administrator.':
        'Invite expired. Please contact your administrator.',
      'Error: Please contact Amplify at help@amplify.com':
        'Error: Please contact Amplify at help@amplify.com',
      'Error: Expiration date loading failed. Please try again later.':
        'Error: Expiration date loading failed. Please try again later.',
      'Assignments Error': 'Assignments Error',
      'Not Entitled': 'Not Entitled',
      'Programs are being set up': 'Programs are being set up',
      'Your programs are not set up': 'Your programs are not set up',
      "<b>Your district's programs are being set up!</b><br /><br />Administrators: visit the <a>Admin Portal</a> to view rosters.":
        "<b>Your district's programs are being set up!</b><br /><br />Administrators: visit the <a>Admin Portal</a> to view rosters.",
      'All Classes': 'All Classes',
      'All Subjects': 'All Subjects',
      'You taught': 'You taught',
      customized: 'customized',
      Save: 'Save',
      'Show/Hide programs you want to have access to in the main Navigation and Home Page.':
        'Show/Hide programs you want to have access to in the main Navigation and Home Page.',
      'At least one product should be selected.':
        'At least one product should be selected.',
      'Error: Editing failed. Please try again later.':
        'Error: Editing failed. Please try again later.',
      'Error: Reassigning failed. Please try again later.':
        'Error: Reassigning failed. Please try again later.',
      'Error: Unassigning failed. Please try again later.':
        'Error: Unassigning failed. Please try again later.',
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
  // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
  // if you're using a language detector, do not define the lng option
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
